import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useChartingCredentialProvisioningConfig() {
  return useCbhFlag(CbhFeatureFlag.CHARTING_CREDENTIAL_PROVISIONING_CONFIG, {
    defaultValue: {
      enabled: false,
    },
  });
}
